/**
 * Angular imports.
 */
import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, AbstractControl } from '@angular/forms';

/**
 * Constant imports.
 */
import {
  BREADCRUMB_PATHS, COMMUNITY_PRIVACY, IS_SUGGESTION, MEMBERS_LIST_TYPE, MEDIA_DIMENSIONS, NUMBERS, COMMUNITY_PROFILE_IMAGE_FILE_SIZE,
  COMMUNITY_MEMBERS_ACTION, IMAGE_FILES_TYPE, IMAGE_FILES_EXTENSIONS, NUDGE, SCREEN_NAME, PRODUCT_TYPE_CONSTANT, COMMUNITY_JOIN_TYPE,
  PRODUCT_TYPE_CONSTANT_NAME,
  CTA_TYPE,
  ACTION_TYPE,
  ACTION_ON,
  TRANSACTION_TYPE,
  COMMUNITY_CONSTANT
} from '../../constants/app.constants';
import { EVENT_NAME } from '../../analytics-event/analytics.constant';

/**
 * Validations import.
 */
import { NoSpaceValidator } from './../../validators/noSpaceValidator/noSpace.validator';

/**
 * Service imports.
 */
import { NewLanguageService } from './../../dataservices/new-language/new-language.service';
import { MasterserviceService } from '../../dataservices/master-service/masterservice.service';
import { CreateCommunityService } from './create-community.service';
import { ActivatedRoute } from '@angular/router';
import { GetService } from './../../dataservices/get.service';
import { CommunityDetailResponse } from '../../onboarding/interface/apiResponse.model';
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { DataStorageService } from './../../dataservices/data-storage.service';
import { JwtDecodeService } from '../../dataservices/jwt-decode.service';
/**
 * SDK IMPORTS
 */
import { Analytics } from 'analytics2.0';

/**
 * Rxjs imports.
 */
import { Subject, Subscription } from 'rxjs';
import { ENTRY, EXIT, ITEM_TRIGGERED, SUBMIT } from 'analytics2.0/dist/core/constants/analytic.interface';
/**
 * To create/Edit the community.
 */
@Component({
  selector: 'app-create-community',
  templateUrl: './create-community.component.html',
  styleUrls: ['./create-community.component.scss'],
  providers: [CreateCommunityService]
})
export class CreateCommunityComponent implements OnInit, OnDestroy {

  /**
   * Form Group for create community.
   * Submitted Flag.
   * Breadcrumb for the create community.
   * Speciality popup label.
   * Speciality selection label.
   * Speciality selection limit.
   * No Speciality found message.
   * Speciality max limit error message.
   * speciality filter placeholder text.
   * Check speciality selection open/close.
   * Store the selected speciality List.
   * Store the pre selected clone for speciality selected list.
   * Check members selection open/close.
   * Members selection label.
   * Members popup label.
   * Members filter placeholder text.
   * No member found message.
   * Members selected list title.
   * Max members selected limit.
   * Members Title for the popup.
   * Members max limit error label.
   * Selected Members list.
   * Members is view all enable/disabled.
   * Flag decided to rest the suggestion list aur add into the list for members suggestion.
   * Only alpha numeric are allowed msg.
   * Banner Data
   * @numbers for Number Constant
   */
  public communityForm: UntypedFormGroup;
  public submitted = false;
  public createCommunityBreadcrumb = [
    { name: this.mls.languageText.community.key25, path: BREADCRUMB_PATHS.HOME },
    { name: this.mls.languageText.community.key1, path: BREADCRUMB_PATHS.COMMUNITY_LIST },
    { name: this.mls.languageText.community.key34, path: '' },
  ];
  public specialityPopupLabel = `${this.mls.languageText.community.key16} ${this.mls.languageText.community.key20}`;
  public specialitySelectionLabel = this.mls.languageText.community.key20;
  public specialityCompleteSelectionLabel = this.mls.languageText.community.key12;
  public specialityTitleLabel = this.mls.languageText.community.key20;
  public specialitySelectionLimit = 5;
  public noSpecialityFound = this.mls.languageText.community.key13;
  public specialityMaxLimitError = this.mls.languageText.community.key14;
  public specialityMaxLimitErrorLabel = this.mls.languageText.community.key33;
  public specialityFilterPlaceholder = this.mls.languageText.community.key15;
  public isSpecialitySelectionOpen = false;
  public specialityList = [];
  public specialityPreSelectedList = [];
  public isMembersSelectionOpen = false;
  public membersSelectionLabel = this.mls.languageText.community.key12;
  public membersPopupLabel = `${this.mls.languageText.community.key16} ${this.mls.languageText.community.key19}`;
  public membersFilterPlaceholder = this.mls.languageText.community.key26;
  public membersNoDataFoundLabel = this.mls.languageText.community.key17;
  public membersSelectedTitle = this.mls.languageText.community.key18;
  public membersSelectedLimit = 10000;
  public membersTitle = this.mls.languageText.community.key19;
  public membersMaxLimitErrorLabel = this.mls.languageText.community.key14;
  public selectedMembers = [];
  public membersIsViewAllEnable = false;
  public isMemberConcat = true;
  public communityId = '';
  public inputFile = [];
  public isInfoModalShown = false;
  public displayObj = {
    isShow: false,
    display_section: '',
    data: [],
    errObj: []
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public communityData: any = {};
  public communityPic = '';
  public bannerData = [];
  private membersSearchType = MEMBERS_LIST_TYPE.CONNECTION;
  private membersIsSuggestion = IS_SUGGESTION.YES;
  private membersKeyword = '';
  private preSelectedMembersList = [];
  private originalSelectedMembersList = [];
  public showMobileBackButtonFlag = false;
  public showExistingUsersFlag = false;
  /**
   * Member count to show on modal.
   */
  public memberCount: number;
  /**
   * Offset for selected member.
   */
  public offset: number;
  /**
   * Selected member removed
   */
  public membersSelectedRemoved = [];
  public privacy = COMMUNITY_PRIVACY.PUBLIC;
  public join_option: string;
  public showJoinModal = false;
  public nudge_offset = NUDGE.CONSTANT;
  public nudge_action_type = NUDGE.ACTION;
  public privacies = COMMUNITY_PRIVACY;
  public communityType = COMMUNITY_CONSTANT;

  /**
   * Analytics session time.
   */
  private sessiontime = { 'start_time': '', 'end_time': '' };
  /**
   * Numbers import
   */
  public numbers = NUMBERS;
  public join_type = COMMUNITY_JOIN_TYPE.AUTOMATIC;
  public joining_option = COMMUNITY_JOIN_TYPE;
  public callingFrom = SCREEN_NAME.COMMUNITY_EDIT_PAGE;
  /**
   * List for adding members
   */
  public memberToBeAdded = [];
  /**
   * Variable for maintaing count
   */
  public count = NUMBERS.ZERO;
  /**
   * Variable for maintaing count handling after api hit
   */
  public maintainedCount: number;
  
  /**
   * To check type of community
   */
  public  type: string;

  /**
   * advance settting option pop up
   */
  public advSettingStartTime: number;

  /**
   * select 
   */
  public selectSpeciailitypopUpStartTime: number;



  /**
   * convenience getter for easy access to form fields
   */
  get title(): AbstractControl { return this.communityForm.get('title'); }
  get speciality(): AbstractControl { return this.communityForm.get('speciality'); }
  get members(): AbstractControl { return this.communityForm.get('members'); }
  get description(): AbstractControl { return this.communityForm.get('description'); }
  /**
   * Unsubscribe the subscription.
   */
  private subscriptions: Subscription = new Subscription();

   /**
   * @notifier$ defines a notifier subject stream to end data streaming
   */
  private notifier$ = new Subject();
  /**
   * Necessary instances.
   */
  constructor(
    private formBuilder: UntypedFormBuilder,
    public createCommunityService: CreateCommunityService,
    public mls: NewLanguageService,
    public route: ActivatedRoute,
    public masterService: MasterserviceService,
    public getApiService: GetService,
    public fcs: FunCollectionService,
    public dss: DataStorageService,
    public jwtSer: JwtDecodeService,
    public getSer: GetService,
    private analyticSdk: Analytics
  ) {
    if(this.route.snapshot.routeConfig.path==COMMUNITY_CONSTANT.CREATE_COMMUNITY){
      this.type=COMMUNITY_CONSTANT.CREATE
    }
    this.communityId = this.route.snapshot.params[COMMUNITY_CONSTANT.COMMUNITY_ID];

  }

  /**
   * Call initialize Form.
   */
  ngOnInit(): void {
    /**
     * Session start time.
     */
    this.sessiontime.start_time = new Date().getTime().toString();
    this.initializeForm();
    this.createCommunityService.getSpecialityList();
    this.createCommunityService.communityDisableCheck();
    if (this.communityId) {
      this.editCommunity();
    }
    else {
      const entryData:  ENTRY = {
        entity_type: PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY,
        entity_code: 0,
        start_time: parseInt(this.sessiontime.start_time),
        source: this.fcs.currentScreename ?? localStorage.getItem('triggerSource'),
        current_screen_name: SCREEN_NAME.C0MMUNITY_CREATION
      }
      this.analyticSdk.analyticService.ENTRY(entryData);
      this.fcs.currentScreename = SCREEN_NAME.C0MMUNITY_CREATION
    }
    if (!this.communityId) {
      this.subscriptions.add(this.getSer.getNudgeData(this.nudge_offset, this.nudge_action_type)
        .subscribe(resData => {
          this.jwtSer.decodeData(resData).then(data => {
            if (data.status === NUMBERS.ONE) {
              this.privacy = data.data.community.default_privacy_type;
              this.communityForm.patchValue({ privacy: this.privacy });
            } else {
              this.fcs.errorHandeler(resData);
            }

          }, (err) => {
            this.fcs.errorHandeler(err);
          });
        }));
    }

  }


  /**
   * initialize the create community form.
   */
  initializeForm(): void {
    this.communityForm = this.formBuilder.group({
      title: ['', [Validators.required, NoSpaceValidator]],
      description: [''],
      privacy: ['', Validators.required],
      speciality: [''],
      members: ['', Validators.required],
      join_type: [COMMUNITY_JOIN_TYPE.AUTOMATIC, Validators.required]

});
  }
  searchInConnectionList(keyword: string): void {
    this.createCommunityService.membersSuggestionOffset = 1;
    this.membersKeyword = keyword;
    this.callConnectionList(this.isMemberConcat);
  }

  callConnectionList(isMemberConcat: boolean): void {
    this.createCommunityService.connectionList(this.membersSearchType, this.createCommunityService.membersSuggestionOffset, this.membersIsSuggestion, this.membersKeyword, {}, isMemberConcat, this.communityId);
  }

  backToMembersSuggestion(): void {
    this.membersIsSuggestion = 1;
    this.createCommunityService.membersSuggestionOffset = 1;
    this.membersSearchType = MEMBERS_LIST_TYPE.CONNECTION;
    this.membersIsViewAllEnable = false;
    this.callConnectionList(this.isMemberConcat);
  }

  viewAllMembers(key: string): void {
    this.createCommunityService.membersSuggestionOffset = 1;
    this.membersIsSuggestion = (key === MEMBERS_LIST_TYPE.CONNECTION) ? IS_SUGGESTION.NO : IS_SUGGESTION.YES;
    this.membersSearchType = (key === MEMBERS_LIST_TYPE.CONNECTION) ? MEMBERS_LIST_TYPE.CONNECTION : MEMBERS_LIST_TYPE.SUGGESTION;
    this.callConnectionList(this.isMemberConcat);
    this.membersIsViewAllEnable = true;
  }

  onMembersScroll(): void {
    if (this.createCommunityService.membersSuggestionOffset > 1 && this.membersIsViewAllEnable) {
      this.callConnectionList(!this.isMemberConcat);
    }
  }

  /**
   * Set the speciality value.
   */
  setSpeciality(): void {
    const exitData: EXIT = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY,
      entity_code: this.communityData?.da_id ?? 0,
      start_time: this.selectSpeciailitypopUpStartTime,
      current_screen_name: SCREEN_NAME.COMMUNITY_ADD_SPECIALITY,
      end_time: new Date().getTime()
    }
    this.analyticSdk.analyticService.EXIT(exitData);
    this.isSpecialitySelectionOpen = false;
    this.specialityPreSelectedList = [...this.specialityList];
    this.speciality.setValue(`${this.specialityPreSelectedList.length} ${this.membersSelectedTitle}`);
  }

  /**
   * open Speciality popup.
   */
  openSpecialityPopup(): void {
    this.selectSpeciailitypopUpStartTime = new Date().getTime();
    const entryData: ENTRY = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY,
      entity_code: this.communityData?.da_id ?? 0,
      start_time: this.selectSpeciailitypopUpStartTime,
      source: this.fcs.currentScreename,
      current_screen_name: SCREEN_NAME.COMMUNITY_ADD_SPECIALITY
    }
    this.analyticSdk.analyticService.ENTRY(entryData);
    this.isSpecialitySelectionOpen = true;
  }

  /**
   * Close Speciality popup.
   */
  closeSpecialityPopup(): void {
    this.isSpecialitySelectionOpen = false;
    const exitData: EXIT = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY,
      entity_code: this.communityData?.da_id ?? 0,
      start_time: this.selectSpeciailitypopUpStartTime,
      current_screen_name: SCREEN_NAME.COMMUNITY_ADD_SPECIALITY,
      end_time: new Date().getTime()
    }
    this.analyticSdk.analyticService.EXIT(exitData);
    this.specialityList = [...this.specialityPreSelectedList];
  }

  /**
   * Set the speciality value.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setMembers(analyticsStatus: boolean, membersSelectedRemoved?: any): void {
    this.membersSelectedRemoved = membersSelectedRemoved;
    if (analyticsStatus) {
      const d = new Date();
      this.sessiontime.start_time = d.getTime().toString();
    }
    if (!this.communityId) {
      this.isMembersSelectionOpen = false;
      this.preSelectedMembersList = [...this.selectedMembers];
      this.members.setValue(`${this.memberToBeAdded.length} ${this.membersSelectedTitle}`);
    }
  }

  /**
   * open Speciality popup.
   */
  openMembersPopup(): void {
    if (this.selectedMembers.findIndex(x => x.custom_id === this.createCommunityService.loggedInUser.custom_id) === NUMBERS.MINUS_ONE) {
      this.selectedMembers.push(this.createCommunityService.loggedInUser);
    }
    this.membersIsViewAllEnable = false;
    this.createCommunityService.membersSuggestionList = [];
    this.membersSearchType = MEMBERS_LIST_TYPE.CONNECTION;
    this.membersIsSuggestion = 1;
    this.membersKeyword = '';
    this.createCommunityService.membersSuggestionOffset = 1;
    if (!this.communityId) {
      this.callConnectionList(this.isMemberConcat);
    }

    this.isMembersSelectionOpen = true;
    if (!this.communityId && !this.memberCount) {
      this.memberCount = this.selectedMembers.length || NUMBERS.ONE;
    }

    if (this.communityId) {
      this.getMemberCount();
    }
  }

  /**
   * Close member popup.
   */
  closeMembersPopup(): void {
    this.isMembersSelectionOpen = false;
    this.selectedMembers = [...this.preSelectedMembersList];
    this.memberCount = !this.communityId ? undefined : this.communityData['members'].count;
    if (this.communityId || !this.memberCount) {
      this.membersSelectedRemoved = [];
    }

  }

  /**
   * Submit the create/update community.
   */
  onSubmit(): void {
    const submitData: SUBMIT = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY,
      entity_code: this.communityData?.da_id ?? '0',
      current_screen_name: SCREEN_NAME.C0MMUNITY_CREATION,
      start_time: new Date().getTime(),
      action_on: ACTION_ON.CREATE_COMMUNITY,
      cta_type: CTA_TYPE.BUTTON,
      action_type: ACTION_TYPE.CLICK
    }
    this.analyticSdk.analyticService.SUBMIT(submitData);
    this.communityForm.patchValue({ privacy: (this.communityForm.value.privacy === COMMUNITY_PRIVACY.DEFAULT) ? this.dss.backgroundCommunity.default_privacy_type : this.communityForm.value.privacy });
    this.submitted = true;
    if (this.communityId) {
      this.preSelectedMembersList.forEach((data) => {
        data['action'] = COMMUNITY_MEMBERS_ACTION.ADD;
      });
      const result = this.originalSelectedMembersList.filter((a1) => {
        a1.ation = COMMUNITY_MEMBERS_ACTION.ADD;
        return !this.preSelectedMembersList.some((a2) => {
          return a1.custom_id === a2.custom_id;
        });
      });
      result.forEach((data) => {
        data['action'] = COMMUNITY_MEMBERS_ACTION.REMOVE;
      });
      // finalMembersList = this.preSelectedMembersList.concat(result);
      this.createCommunityService.updateCommunity(this.communityForm.value, this.bannerData, this.specialityPreSelectedList, this.communityId, true, this.dss.callingFromCommunityForEdit);
    } else {
      this.createCommunityService.submitCommunity(this.communityForm.value, this.specialityPreSelectedList, this.memberToBeAdded, this.bannerData);
    }
  }
  /**
   * Edit Community
   */
  editCommunity(): void {
    let communityDetail;
    // const specialitiesList = {};
    this.createCommunityBreadcrumb = [
      { name: this.mls.languageText.community.key25, path: BREADCRUMB_PATHS.HOME },
      { name: this.mls.languageText.community.key1, path: BREADCRUMB_PATHS.COMMUNITY_LIST },
      { name: `${this.mls.languageText.community.key5} ${this.mls.languageText.community.key1}`, path: '' },
    ];
    this.subscriptions.add(this.getApiService.getCommunityDetail(this.communityId).subscribe((res: CommunityDetailResponse) => {
      if (res.status === NUMBERS.ONE) {
        communityDetail = res.data.detail;
        this.communityData = res.data.detail;
        const entryData:  ENTRY = {
          entity_type: PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY,
          entity_code: this.communityData?.da_id ?? 0,
          start_time: parseInt(this.sessiontime.start_time),
          source: this.fcs.currentScreename ?? localStorage.getItem('triggerSource'),
          current_screen_name: SCREEN_NAME.C0MMUNITY_CREATION
        }
        this.analyticSdk.analyticService.ENTRY(entryData);
        this.fcs.currentScreename = SCREEN_NAME.C0MMUNITY_CREATION
        this.privacy = communityDetail.privacy;
        this.createCommunityService.postSubmitting = NUMBERS.ZERO;
        this.join_type = communityDetail.join_type;
        this.setMembers(null);
        this.communityPic = communityDetail.media_list.length && communityDetail.media_list[0]['media_url'] !== 'string' ? communityDetail.media_list[0]['media_url'] : '';
        this.communityForm.patchValue({
          title: communityDetail.title,
          description: communityDetail.description,
          privacy: communityDetail.privacy,
          speciality: '',
          members: '',
        });
        this.count = this.communityData['members'].count;
        this.maintainedCount = this.count;
        this.members.setValue(`${this.communityData['members'].count} ${this.membersSelectedTitle}`);
        this.memberCount = this.communityData['members'].count;
        if (COMMUNITY_PRIVACY.PUBLIC === communityDetail.privacy) {
          this.communityForm.patchValue({
            join_type: communityDetail.join_type
          });
        }
        if (communityDetail.media_list && communityDetail.media_list[0] && communityDetail.media_list[0]['media_id']) {
          this.bannerData = [{
            'id': communityDetail.media_list.length ? communityDetail.media_list[0]['media_id'] : 0,
            'path': communityDetail.media_list.length ? communityDetail.media_list[0]['media_url'] : 'string',
            'name': communityDetail.media_list.length ? communityDetail.media_list[0]['media_name'] : 'string',
            'height': communityDetail.media_list.length ? communityDetail.media_list[0]['media_height'] : MEDIA_DIMENSIONS.HEIGHT,
            'width': communityDetail.media_list.length ? communityDetail.media_list[0]['media_width'] : MEDIA_DIMENSIONS.WIDTH,
            'resolution': MEDIA_DIMENSIONS.RESOLUTION
          }];
        } else {
          this.bannerData = [];
        }

        this.specialityPreSelectedList = [...communityDetail.specialties.map((data) => ({ 'id': data.speciality_id, 'name': data.speciality_name }))];
        this.specialityList = [...this.specialityPreSelectedList];
        this.speciality.setValue(`${this.specialityPreSelectedList.length} ${this.membersSelectedTitle}`);
      } else {
        this.fcs.errorHandeler(res);
      }
    }, (err) => this.fcs.errorHandeler(err)));
  }

  /**
   * on clicking the banner 
   */
  bannerEditClicked(): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY,this.communityData?.da_id ?? '0', SCREEN_NAME.COMMUNITY_DETAIL, CTA_TYPE.ICON, ACTION_TYPE.CLICK, ACTION_ON.ADD_COMMUNITY_BANNER, null);
  }
  /**
   * on Select Edit File.
   */
  onSelectEditFile(e): boolean {
    const file = e.target.files[0];
    const display_section = 'successModal';
    const messageTitle = 'Error';
    let messageDesc = '';
    const fileExtension = file?.name?.split('.')?.pop()?.toLowerCase();
    if ((Object.values(IMAGE_FILES_TYPE).indexOf(file.type) > -1) && (Object.values(IMAGE_FILES_EXTENSIONS).indexOf(fileExtension) > -1)) {
      if (file.size > COMMUNITY_PROFILE_IMAGE_FILE_SIZE) {
        messageDesc = this.mls.languageText.community.key35;
        this.showErrorSuccessMessage(display_section, messageTitle, messageDesc);
      } else {
        for (let i = 0; i < e.target.files.length; i++) {
          this.inputFile.push(e.target.files[i]);
        }
      }
    } else {
      messageDesc = this.mls.languageText.community.key36;
      this.showErrorSuccessMessage(display_section, messageTitle, messageDesc);
    }
    e.target.value = '';
    return false;
  }

  /**
   * cancel Update profile Pic.
   */
  cancelUpdateCommunityPic(): void {
    this.inputFile = [];
  }

  /**
   * update Profile Pic.
   */
  updateCommunityPic(data): void {
    const display_section = 'successModal';
    const messageTitle = 'success';
    const messageDesc = this.mls.languageText.profile_edit_basic.key32;
    this.showErrorSuccessMessage(display_section, messageTitle, messageDesc);
    this.communityPic = data.media.media_thumbnail;
    this.bannerData = [{
      'id': 0,
      'path': data.media.media_url,
      'name': data.media.media_name,
      'height': MEDIA_DIMENSIONS.HEIGHT,
      'width': MEDIA_DIMENSIONS.WIDTH,
      'resolution': MEDIA_DIMENSIONS.RESOLUTION
    }];
    if ((Object.keys(this.communityData).length)) {
      this.bannerData[0]['id'] = data.media.media_id;
    }
  }

  /**
   * Show Error or Success Message
   */
  showErrorSuccessMessage(display_section, message_title, message_description): void {
    this.displayObj = {
      isShow: false,
      display_section: '',
      data: [],
      errObj: []
    };
    this.displayObj.display_section = display_section;
    const temp = { data: { message_title, message_description } };
    this.displayObj.data.push(temp);
    this.displayObj.isShow = true;
    this.masterService.showWebModal.next(this.displayObj);
    this.inputFile = [];
  }

  /**
   * Remove Community Pic
   */
  removeCommunityPic(): void {
    if (this.communityId) {
      this.bannerData = [];
      this.inputFile = [];
      this.communityPic = '';
    }
  }

  /**
   * Updating the privacy value to public
   */
  updatePrivacyPublic(): void {
    this.communityForm.patchValue({ privacy: COMMUNITY_PRIVACY.PUBLIC });
    this.privacy = COMMUNITY_PRIVACY.PUBLIC;
  }

  /**
   * Updating the privacy value to private
   */
  updatePrivacyPrivate(): void {
    this.communityForm.patchValue({ privacy: COMMUNITY_PRIVACY.PRIVATE });
    this.privacy = COMMUNITY_PRIVACY.PRIVATE;
  }

  /**
   * For exitting the pop up
   */
  enterPopup(): void {
    this.showJoinModal = true;
    this.advSettingStartTime = new Date().getTime();
    const entryData:  ENTRY = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY,
      entity_code: this.communityData?.id ?? 0,
      start_time: this.advSettingStartTime,
      source: this.fcs.currentScreename,
      current_screen_name: SCREEN_NAME.COMMUNITY_SETTINGS
    }
    const itemTriggeredData: ITEM_TRIGGERED = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY,
      entity_code: this.communityData?.da_id ?? 0,
      current_screen_name: SCREEN_NAME.C0MMUNITY_CREATION,
      transaction_type: TRANSACTION_TYPE.COMMUNITY_SETTINGS_POPUP,
      start_time: new Date().getTime()
    }
    this.analyticSdk.analyticService.ITEM_TRIGGERED(itemTriggeredData);
    this.analyticSdk.analyticService.ENTRY(entryData);

  }

  /**
   * When user click on close or ESC.
   */
  onHidden(): void {
    this.showJoinModal = false;
    const exitData:  EXIT = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY,
      entity_code: this.communityData?.da_id ?? 0,
      start_time: this.advSettingStartTime,
      current_screen_name: SCREEN_NAME.COMMUNITY_SETTINGS,
      end_time: new Date().getTime()
    }
    this.analyticSdk.analyticService.EXIT(exitData);
  }
  /**
   * for join_type automatic
   */
  joinTypeAutomatic(): void {
    this.communityForm.patchValue({ join_type: COMMUNITY_JOIN_TYPE.AUTOMATIC });
    this.join_type = COMMUNITY_JOIN_TYPE.AUTOMATIC;
  }

  /**
   * for join_type approval
   */
  joinTypeApproval(): void {
    this.communityForm.patchValue({ join_type: COMMUNITY_JOIN_TYPE.APPROVAL });
    this.join_type = COMMUNITY_JOIN_TYPE.APPROVAL;
  }

  /**
   * On Existing User Flag
   */

  onExistingUserFlag(event): void {
    this.showMobileBackButtonFlag = event;
  }

  /**
   * On Return to Original Members List
   */

  emitOriginalBack(event): void {
    this.showMobileBackButtonFlag = event;
  }


  /**
   * Clear the subscription.
   */
  ngOnDestroy(): void {
    const exitData:  EXIT = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY,
      entity_code: this.communityData?.da_id ?? 0,
      start_time: parseInt(this.sessiontime.start_time),
      current_screen_name: SCREEN_NAME.C0MMUNITY_CREATION,
      end_time: new Date().getTime()
    }
    this.analyticSdk.analyticService.EXIT(exitData);
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
    this.notifier$.next();
    this.notifier$.complete();
    this.dss.callingFromCommunityForEdit = NUMBERS.ZERO;


    /**
     * Calculate end time on destroy.
     */
    this.sessiontime.end_time = new Date().getTime().toString();
  }
  /**
   * Check or uncheck members.
   */
  checkUncheckMember(event: boolean): void {
    if (!this.memberCount) {
      this.memberCount = NUMBERS.ZERO;
    }
    if (event) {
      this.memberCount = this.memberCount + NUMBERS.ONE;
    } else {
      this.memberCount = this.memberCount - NUMBERS.ONE;
    }
  }
  /**
   * Selected members.
   */
  membersSelected(data): void {
    const index = this.membersSelectedRemoved.findIndex((item) => {
      return item.custom_id === data.custom_id;
    });
    if (index != -NUMBERS.ONE) {
      this.membersSelectedRemoved.splice(index, NUMBERS.ONE);
    }
    this.membersSelectedRemoved.push(data);
  }
  /**
   * Remove selcted members.
   */
  membersRemoved(data): void {
    const index = this.membersSelectedRemoved.findIndex((item) => {
      return item.custom_id === data.custom_id;
    });
    if (index != -NUMBERS.ONE) {
      this.membersSelectedRemoved.splice(index, NUMBERS.ONE);
    }
    if (data.is_community_member) {
      this.membersSelectedRemoved.push(data);
    }
  }


  getMemberCount(): void {
    this.getApiService.getCommunityDetail(this.communityId).subscribe((res: CommunityDetailResponse) => {
      if (res.status === NUMBERS.ONE) {
        this.memberCount = res.data.detail.members.count;
      }
    });
  }
  /**
   * Set value for count
   */
  addMember(event): void {
    this.memberToBeAdded = event;
    if (this.createCommunityService.removeState === NUMBERS.ZERO) {
      this.count = this.count + event.length;
    }
    if (this.createCommunityService.removeState === NUMBERS.ONE) {
      this.count = this.count - event.length;
      this.createCommunityService.communityCount = this.memberToBeAdded.length;
    }
  }

  /**
   * For setting value of count
   */
  clearAll(): void {
    this.memberToBeAdded = [];
    if (!this.communityId) {
      this.members.setValue(`${this.memberToBeAdded.length} ${this.membersSelectedTitle}`);
    }
    if (this.communityId) {
      { this.members.setValue(`${this.maintainedCount} ${this.membersSelectedTitle}`); }
    }
    this.createCommunityService.communityCount = NUMBERS.ZERO;
  }
  /**
   * For updating community count
   */
  updateCommunity(event): void {
    if (event === false) {
      this.count = this.maintainedCount;
      this.members.setValue(`${this.count} ${this.membersSelectedTitle}`);
    } else {
      this.maintainedCount = this.count;
      this.members.setValue(`${this.count} ${this.membersSelectedTitle}`);
    }
  }

  // back method
  back(id: string | number): void {
    if (id) {
      this.fcs.navigateToCommunityDetailPage(id);
    } else {
      this.fcs.navigateToCommunityModule();
    }
  }

}
